import { render } from "./QVPExamResult.vue?vue&type=template&id=3c5352fc&scoped=true"
import script from "./QVPExamResult.vue?vue&type=script&lang=js"
export * from "./QVPExamResult.vue?vue&type=script&lang=js"

import "./QVPExamResult.vue?vue&type=style&index=0&id=3c5352fc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c5352fc"]])

export default __exports__